<template>
  <MainHeader />
  <div class="content">
    <div id="emploi" class="container">
      <h1>Poste à pourvoir</h1>
      <hr />

      <!-- Mobile: Toggle button (shown under 768px) -->
      <button
        class="sidebar-toggle"
        @click="isMobileSidebarOpen = true"
        aria-label="Ouvrir la liste des postes"
      >
        📄 Voir les offres
      </button>

      <div v-if="pdfFiles.length" class="layout">
        <!-- Overlay for mobile drawer -->
        <div
          class="backdrop"
          v-if="isMobileSidebarOpen"
          @click="closeMobileSidebar"
        ></div>

        <!-- Sidebar: PDF selection -->
        <aside
          class="sidebar"
          :class="{ open: isMobileSidebarOpen }"
          @keydown.esc="closeMobileSidebar"
        >
          <!-- Mobile header inside drawer -->
          <div class="sidebar-head">
            <span>Offres</span>
            <button
              class="close-btn"
              @click="closeMobileSidebar"
              aria-label="Fermer"
            >
              ✕
            </button>
          </div>

          <ul class="pdf-list" @click="maybeCloseOnMobile">
            <li
              v-for="(pdf, index) in pdfFiles"
              :key="pdf.filename"
              :class="{ active: index === selectedIndex }"
              @click="selectPdf(index)"
            >
              {{ formatFileName(pdf.filename) }}
            </li>
          </ul>
        </aside>

        <!-- Main content: selected PDF -->
        <div class="viewer">
          <div class="card-container">
            <transition name="fade" mode="out-in" appear>
              <EmploiCard :pdfFile="selectedPdf" :key="selectedIndex" />
            </transition>
          </div>
        </div>
      </div>
      <h3 v-else style="text-align: center;">Aucun poste à pourvoir pour le moment.</h3>
    </div>
  </div>
  <MainFooter />
</template>

<script>
import MainHeader from '../global/MainHeader.vue';
import MainFooter from '../global/MainFooter.vue';
import EmploiCard from './parts/EmploiCard.vue';

export default {
  name: 'EmploiMain',
  components: { MainHeader, MainFooter, EmploiCard },
  data() {
    return {
      pdfFiles: [],
      selectedIndex: 0,
      apiBaseUrl: process.env.VUE_APP_API_HOST,
      // Mobile sidebar state
      isMobileSidebarOpen: false,
      // Switching guard vars you already used
      isSwitching: false,
      switchDelayMs: 160
    };
  },
  computed: {
    selectedPdf() {
      return this.pdfFiles[this.selectedIndex] || {};
    }
  },
  mounted() {
    this.fetchPDFList();
  },
  methods: {
    async fetchPDFList() {
      try {
        const res = await fetch(`${this.apiBaseUrl}/pdf/list`);
        const result = await res.json();
        if (result.success) {
          this.pdfFiles = result.files;
        } else {
          console.error('Failed to fetch PDFs:', result.message);
        }
      } catch (err) {
        console.error('Failed to fetch PDFs:', err);
      }
    },
    async selectPdf(index) {
      if (index === this.selectedIndex || this.isSwitching) return;
      this.isSwitching = true;
      this.selectedIndex = index;
      await this.$nextTick();
      setTimeout(() => { this.isSwitching = false; }, this.switchDelayMs);
    },
    formatFileName(filename) {
      if (!filename) return "Poste à pourvoir";
      return filename
        .replace(/\.pdf$/i, '')
        .replace(/[_-]/g, ' ')
        .split(' ')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join(' ');
    },
    closeMobileSidebar() {
      this.isMobileSidebarOpen = false;
    },
    // Close drawer after tapping an item (on small screens)
    maybeCloseOnMobile() {
      if (window.matchMedia('(max-width: 768px)').matches) {
        this.closeMobileSidebar();
      }
    }
  }
};
</script>

<style scoped>
  .close-btn {
    display: none;
  }
   .sidebar-head {
    display: none;
  }
.content {
  background-color: #49584C;
  min-height: 80vh;
}
#emploi {
  margin-top: 5vh;
  margin-bottom: 10vh;
}
#emploi > h1 {
  text-align: center;
  color: white;
  margin-bottom: 15px;
  font-weight: 700;
}
#emploi hr {
  width: 15vh;
  border: none;
  border-bottom: 2px solid rgba(255, 255, 255, 0.3);
  margin: 0 auto 5vh auto;
}
.layout {
  display: flex;
  gap: 30px;
}

/* ---------- Sidebar base ---------- */
.sidebar {
  width: 250px;
  background: #37463C;
  border-radius: 10px;
  padding: 15px;
  transition: transform 0.25s ease, box-shadow 0.25s ease;
  will-change: transform;
  z-index: 20;
}
.pdf-list {
  list-style: none;
  padding: 0;
  margin: 0;
}
.pdf-list li {
  color: white;
  padding: 10px;
  margin-bottom: 10px;
  background: #213025;
  border-radius: 6px;
  cursor: pointer;
  transition: background 0.2s;
}
.pdf-list li:hover {
  background: #2c3e2d;
}
.pdf-list li.active {
  background: #2c974b;
  font-weight: bold;
}

/* Crossfade */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 160ms ease, transform 160ms ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
  transform: translateY(4px);
}

.viewer {
  flex: 1;
  min-height: 70vh;
  display: flex;
}
.card-container {
  flex: 1;
  background: transparent;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 5px 15px rgba(0,0,0,.2);
  display: flex;
  flex-direction: column;
  align-items: center;
  will-change: opacity, transform;
  contain: content;
}
.card-title {
  padding: 15px;
  background-color: #213025;
  color: white;
  font-weight: 600;
  font-size: 1.1rem;
  text-align: center;
  border-bottom: 2px solid rgba(0, 0, 0, 0.1);
}
.card-actions {
  padding: 15px;
  display: flex;
  justify-content: center;
  background-color: #f5f5f5;
  border-top: 1px solid #eaeaea;
  margin-top: auto;
}
.download-btn {
  background-color: #2c974b;
  color: white;
  padding: 8px 16px;
  border-radius: 6px;
  text-decoration: none;
  font-weight: 500;
  transition: background-color 0.2s;
  text-align: center;
}
.download-btn:hover {
  background-color: #217a38;
  color: white;
}
h3 {
  color: white;
  margin-top: 40px;
}
.container {
  min-width: clamp(300px, 90%, 2000px);
  padding: 0 20px;
  min-height: 70vh;
}

/* ---------- Mobile enhancements ---------- */
.sidebar-toggle {
  display: none;
  margin: 0 auto 16px auto;
  padding: 10px 14px;
  background: #2c974b;
  color: white;
  border: none;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
  box-shadow: 0 2px 6px rgba(0,0,0,.25);
}
.sidebar-toggle:active {
  transform: translateY(1px);
}

.backdrop {
  display: none;
}

/* Reduced motion */
@media (prefers-reduced-motion: reduce) {
  .fade-enter-active,
  .fade-leave-active,
  .sidebar {
    transition: none;
  }
}

/* ---------- Small screens ---------- */
@media screen and (max-width: 768px) {
  .layout {
    flex-direction: column;
    gap: 16px;
  }

  /* Show toggle button on mobile */
  .sidebar-toggle {
    display: block;
    position: sticky;
    top: 8px;
  }

  /* Off-canvas drawer */
  .sidebar {
    position: fixed;
    inset: 0 auto 0 0; /* left drawer */
    height: 100vh;
    max-width: 88%;
    width: 320px; /* cap width on tablets */
    border-radius: 0 10px 10px 0;
    transform: translateX(-102%);
    box-shadow: 0 10px 30px rgba(0,0,0,.35);
    padding-top: 12px;
    overflow-y: auto;
  }
  .sidebar.open {
    transform: translateX(0);
  }

  .sidebar-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: #fff;
    font-weight: 700;
    padding: 8px 8px 12px 8px;
    margin: 0 0 6px 0;
    position: sticky;
    top: 0;
    background: linear-gradient(180deg, rgba(55,70,60,1) 70%, rgba(55,70,60,0));
    z-index: 1;
  }
  .close-btn {
    display: block;
    background: transparent;
    color: #fff;
    border: 1px solid rgba(255,255,255,.25);
    border-radius: 6px;
    font-size: 14px;
    padding: 4px 8px;
    cursor: pointer;
  }

  /* Dim page under the drawer */
  .backdrop {
    display: block;
    position: fixed;
    inset: 0;
    background: rgba(0,0,0,.4);
    z-index: 15;
  }

  /* Full-width viewer below */
  .viewer {
    flex: none;
    min-height: unset;
  }

  /* Make list items easier to tap */
  .pdf-list li {
    padding: 14px 12px;
    margin-bottom: 12px;
    font-size: 16px;
  }
}
</style>
